import React from 'react';
import '../../styles/sections.css';
import '../../styles/technologies.css';

const Technologies = () => {
  return (
          <section className="technologies-section">
        <div className="section-header">
          <h2>TECHNOLOGIES</h2>
          <div className="underline"></div>
        </div>
        <div className="technologies-content">
        <ul style={{ lineHeight: '1.8', paddingLeft: '1rem' }}>
          <li><strong>Frontend:</strong> ASP.NET Razor Pages</li>
          <li><strong>Backend:</strong> ASP.NET</li>
          <li><strong>Database:</strong> MySQL (phpMyAdmin)</li>
          <li><strong>Hosting:</strong> Azure</li>
          <li><strong>Other:</strong> YouTube API, JWT Authentication</li>
        </ul>
      </div>
    </section>
  );
};

export default Technologies;
